import React, { memo } from 'react';
import { Grid, MenuItem } from '@mui/material';
import FormTextField from './FormTextField';
import FormSelectField from './FormSelectField';

const FormPhoneField = memo(
  ({
    name,
    label,
    formik,
    required,
    error,
    helperText,
    onBlur,
    onChange,
    codigosPais,
    codigoWidth = '40%',
    numeroWidth = '60%',
  }) => {
    // Obtener los valores del objeto teléfono
    const phoneValue = formik.values[name] || { codigo: '+54', numero: '' };
    const codigoValue = phoneValue.codigo;
    const numeroValue = phoneValue.numero;

    // Obtener los errores específicos para cada campo
    const codigoError = formik.touched[`${name}.codigo`] && formik.errors[`${name}.codigo`];
    const numeroError = formik.touched[`${name}.numero`] && formik.errors[`${name}.numero`];

    // Manejar cambios en el código de país
    const handleCodigoChange = (e) => {
      const newValue = e.target.value;
      formik.setFieldValue(`${name}.codigo`, newValue, true);
      // Actualizar el objeto completo
      formik.setFieldValue(
        name,
        {
          ...phoneValue,
          codigo: newValue,
        },
        true,
      );
      onChange?.(e);
    };

    // Manejar cambios en el número
    const handleNumeroChange = (e) => {
      const newValue = e.target.value;
      formik.setFieldValue(`${name}.numero`, newValue, true);
      // Actualizar el objeto completo
      formik.setFieldValue(
        name,
        {
          ...phoneValue,
          numero: newValue,
        },
        true,
      );
      onChange?.(e);
    };

    // Manejar blur en ambos campos
    const handleBlur = (e) => {
      formik.handleBlur(e);
      onBlur?.(e);
    };

    // Convertir el objeto de códigos de país en un array para el select
    const phoneCodesArray = Object.entries(codigosPais || {}).map(([value, label]) => ({
      value,
      label,
    }));

    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} sx={{ width: codigoWidth }}>
          <FormSelectField
            name={`${name}.codigo`}
            label="Código"
            formik={formik}
            required={required}
            error={codigoError}
            value={codigoValue}
            onChange={handleCodigoChange}
            onBlur={handleBlur}
          >
            {phoneCodesArray.map((codigo) => (
              <MenuItem key={codigo.value} value={codigo.value}>
                {codigo.label}
              </MenuItem>
            ))}
          </FormSelectField>
        </Grid>
        <Grid item xs={12} md={8} sx={{ width: numeroWidth }}>
          <FormTextField
            name={`${name}.numero`}
            label={label}
            placeholder="Ingrese el número"
            formik={formik}
            required={required}
            error={numeroError}
            helperText={typeof helperText === 'string' ? helperText : ''}
            onChange={handleNumeroChange}
            onBlur={handleBlur}
            inputType="numeric"
          />
        </Grid>
      </Grid>
    );
  },
);

FormPhoneField.displayName = 'FormPhoneField';

export default FormPhoneField;
